/* globals data, serverParams */
import Table from 'bam-node-savant-table/table'
import { guff } from 'bam-node-baseball-savant/utils/guff'

const { is_team_type } = serverParams

const tableDivId = 'base_running_table'

let currentData = data.slice()

const isFielderView = ['Fld', 'Pit', 'Pitching Team'].includes(
    serverParams.entity_code
)

function loadTable(data) {
    const width = document.getElementById(tableDivId).offsetWidth
    let repeatHeader = false
    if (width <= 768) {
        repeatHeader = 15
    }
    const defaultSort = document.getElementById('sort').value
    const defaultSortDirection = document.getElementById('sortDir').value

    // const keys = Object.keys(data[0]).slice(19, 40)

    // const allHeaders = keys.map((key) => ({
    //     name: key,
    //     field: key,
    //     headerClass: 'th-component-header align-center th-vertical-bottom',
    //     fieldClass: 'tr-data',
    //     type: 'number',
    //     displayFn: (val) => {
    //         if (key.includes('rate')) {
    //             return `${(val * 100).toFixed(1)}`
    //         }
    //         if (key.includes('diff')) {
    //             return `${val.toFixed(2)}`
    //         }

    //         if (key.includes('runs')) {
    //             return `${val.toFixed(1)}`
    //         }
    //         return val
    //     },
    // }))

    const runnerRuns = {
        name: 'Runner <br/>Runs',
        field: 'runner_runs',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data border-left border-right`,
        type: 'number',
        displayFn: (val) => guff(val, 'runner_runs'),
        highlightDynamic: true,
    }

    const fielderRuns = {
        name: 'Fielder <br/>Runs',
        field: 'fielder_runs',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data border-left border-right`,
        type: 'number',
        displayFn: (val) => guff(val, 'fielder_runs'),
        highlightDynamic: true,
    }

    const prefix = isFielderView ? 'fielder' : 'runner'

    const supplementalHeaders = [
        isFielderView ? fielderRuns : runnerRuns,
        {
            name: 'Advances',
            field: `${prefix}_runs_swipe`,
            headerClass: 'th-component-header align-center th-vertical-bottom',
            fieldClass: 'tr-data',
            type: 'number',
            displayFn: (val) => guff(val, `${prefix}_runs_swipe`),
        },
        {
            name: 'Thrown Out',
            field: `${prefix}_runs_snipe`,
            headerClass: 'th-component-header align-center th-vertical-bottom',
            fieldClass: 'tr-data',
            type: 'number',
            displayFn: (val) => guff(val, `${prefix}_runs_snipe`),
        },
        {
            name: 'Holds',
            field: `${prefix}_runs_freeze`,
            headerClass:
                'th-component-header align-center th-vertical-bottom border-right',
            fieldClass: 'tr-data border-right',
            type: 'number',
            displayFn: (val) => guff(val, `${prefix}_runs_freeze`),
        },
        {
            name: 'Advance <br/> Opportunities',
            field: 'n_opp_xb',
            headerClass: 'th-component-header align-center th-vertical-bottom',
            fieldClass: 'tr-data',
            type: 'number',
            displayFn: (val) => {
                if (val) {
                    return Number(val).toLocaleString()
                }

                return val
            },
        },
        // {
        //     name: 'XB Attempts',
        //     field: 'N_att_xb',
        //     headerClass: 'th-component-header align-center th-vertical-bottom',
        //     fieldClass: 'tr-data',
        //     type: 'number',
        //     displayFn: (val) => {
        //         if (val) {
        //             return Number(val).toLocaleString()
        //         }

        //         return val
        //     },
        // },
        {
            name: 'Advance <br/> Attempt %',
            field: 'rate_att_xb',
            headerClass: 'th-component-header align-center th-vertical-bottom',
            fieldClass: 'tr-data',
            type: 'number',
            displayFn: (val) => guff(val, 'rate_att_xb'),
        },
        {
            name: 'Est. Attempt %',
            field: `est_rate_att_generic_${prefix}`,
            headerClass: 'th-component-header align-center th-vertical-bottom',
            fieldClass: 'tr-data',
            type: 'number',
            displayFn: (val) => guff(val, `est_rate_att_generic_${prefix}`),
            toolTip: `Estimated Attempt Rate <br/>for a generic ${prefix} <br/>in the same situations.`,
        },
        {
            name: 'Attempt % <br/> Above Average',
            field: `rate_att_xb_diff_${prefix}`,
            headerClass:
                'th-component-header align-center th-vertical-bottom border-right',
            fieldClass: 'tr-data border-right',
            type: 'number',
            displayFn: (val) => guff(val, `rate_att_xb_diff_${prefix}`),
            toolTip: `Difference between actual attempt rate and estimated attempt rate for a generic ${prefix} in the same situations.`,
        },
        // {
        //     name: 'Outs on XB<br/>Attempts',
        //     field: 'N_out',
        //     headerClass: 'th-component-header align-center th-vertical-bottom',
        //     fieldClass: 'tr-data',
        //     type: 'number',
        //     displayFn: (val) => {
        //         if (val) {
        //             return Number(val).toLocaleString()
        //         }

        //         return val
        //     },
        // },
        {
            name: 'Safe on <br/>Advances',
            field: 'n_safe',
            headerClass: 'th-component-header align-center th-vertical-bottom',
            fieldClass: 'tr-data',
            type: 'number',
            displayFn: (val) => {
                if (val) {
                    return Number(val).toLocaleString()
                }

                return val
            },
        },
        {
            name: 'Safe / Opportunity',
            field: 'rate_safe',
            headerClass: 'th-component-header align-center th-vertical-bottom',
            fieldClass: 'tr-data',
            type: 'number',
            displayFn: (val) => `${(val * 100).toFixed(0)}%`,
        },
        {
            name: 'Safe / Attempt',
            field: 'rate_safe_per_attempt',
            headerClass:
                'th-component-header align-center th-vertical-bottom border-right',
            fieldClass: 'tr-data border-right',
            type: 'number',
            displayFn: (val) => `${(val * 100).toFixed(0)}%`,
        },
        // {
        //     name: 'Out/Opportunity',
        //     field: 'rate_out',
        //     headerClass: 'th-component-header align-center th-vertical-bottom',
        //     fieldClass: 'tr-data',
        //     type: 'number',
        //     displayFn: (val) => `${(val * 100).toFixed(0)}%`,
        // },
        // {
        //     name: 'Out/Attempt',
        //     field: 'rate_out_per_attempt',
        //     headerClass: 'th-component-header align-center th-vertical-bottom',
        //     fieldClass: 'tr-data',
        //     type: 'number',
        //     displayFn: (val) => `${(val * 100).toFixed(0)}%`,
        // },
        // {
        //     name: 'est_rate_safe_generic_runner',
        //     field: 'est_rate_safe_generic_runner',
        //     headerClass: 'th-component-header align-center th-vertical-bottom',
        //     fieldClass: 'tr-data',
        //     type: 'number',
        // },
        // {
        //     name: 'est_rate_out_generic_runner',
        //     field: 'est_rate_out_generic_runner',
        //     headerClass: 'th-component-header align-center th-vertical-bottom',
        //     fieldClass: 'tr-data',
        //     type: 'number',
        // },
        // {
        //     name: 'Est Attempt Rate <br/> (Generic Fielder)',
        //     field: 'est_rate_att_generic_fielder',
        //     headerClass: 'th-component-header align-center th-vertical-bottom',
        //     fieldClass: 'tr-data',
        //     type: 'number',
        //     displayFn: (val) => `${(val * 100).toFixed(1)}`,
        //     toolTip:
        //         'Estimated Attempt Rate <br/> for a generic fielder <br/>in the same situations.',
        // },
        // {
        //     name: 'est_rate_safe_generic_fielder',
        //     field: 'est_rate_safe_generic_fielder',
        //     headerClass: 'th-component-header align-center th-vertical-bottom',
        //     fieldClass: 'tr-data',
        //     type: 'number',
        // },
        // {
        //     name: 'est_rate_out_generic_fielder',
        //     field: 'est_rate_out_generic_fielder',
        //     headerClass: 'th-component-header align-center th-vertical-bottom',
        //     fieldClass: 'tr-data',
        //     type: 'number',
        // },
        // {
        //     name: 'diff_safe',
        //     field: 'diff_safe',
        //     headerClass: 'th-component-header align-center th-vertical-bottom',
        //     fieldClass: 'tr-data',
        //     type: 'number',
        // },
        // {
        //     name: 'diff_safe_generic_runner',
        //     field: 'diff_safe_generic_runner',
        //     headerClass: 'th-component-header align-center th-vertical-bottom',
        //     fieldClass: 'tr-data',
        //     type: 'number',
        // },
        // {
        //     name: 'diff_safe_generic_fielder',
        //     field: 'diff_safe_generic_fielder',
        //     headerClass: 'th-component-header align-center th-vertical-bottom',
        //     fieldClass: 'tr-data',
        //     type: 'number',
        // },
        // {
        //     name: 'diff_safe_generic_all',
        //     field: 'diff_safe_generic_all',
        //     headerClass: 'th-component-header align-center th-vertical-bottom',
        //     fieldClass: 'tr-data',
        //     type: 'number',
        // },
        // {
        //     name: 'diff_out_generic_runner',
        //     field: 'diff_out_generic_runner',
        //     headerClass: 'th-component-header align-center th-vertical-bottom',
        //     fieldClass: 'tr-data',
        //     type: 'number',
        // },
        // {
        //     name: 'diff_out_generic_fielder',
        //     field: 'diff_out_generic_fielder',
        //     headerClass: 'th-component-header align-center th-vertical-bottom',
        //     fieldClass: 'tr-data',
        //     type: 'number',
        // },
        // {
        //     name: 'Fielder <br/>Runs',
        //     field: 'fielder_runs',
        //     headerClass: `th-component-header align-center th-vertical-bottom`,
        //     fieldClass: `tr-data`,
        //     type: 'number',
        //     displayFn: (val) => (-1 * val).toFixed(1),
        // },
    ]

    const headers = [
        {
            name: is_team_type ? 'Team' : 'Player',
            field: 'entity_name',
            customSortField: 'entity_name',
            headerClass: `th-component-header align-left th-vertical-bottom table-static-column`,
            fieldClass: `tr-data align-left table-static-column`,
            photo: is_team_type
                ? undefined
                : '<img class="player-mug" onerror="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
            photoId: 'entity_id',
            defaultSortDir: 'asc',
            displayFn: (entity_name, d) =>
                is_team_type
                    ? entity_name
                    : `<a href="/savant-player/${d.entity_id}">${entity_name}</a>`, // what levels of unsafe is this?
        },
        {
            name: is_team_type ? '' : 'Team',
            field: is_team_type ? 'entity_name' : 'team_name',
            headerClass: `th-component-header`,
            fieldClass: `tr-data`,
            photo: '<img class="table-team-logo" src="{1}" onerror="this.onerror=\'\';this.src=\'/site-core/images/savant-mlb.svg\'" />',
            photoId: 'team_image_url',
            defaultSortDir: 'asc',
            photoOnly: true,
        },
        {
            name: 'Year',
            field: 'start_year',
            headerClass: `th-component-header align-center th-vertical-bottom ${
                serverParams.splitYears ? '' : ' hide'
            }`,
            fieldClass: `tr-data ${serverParams.splitYears ? '' : ' hide'}`,
        },
        ...supplementalHeaders,
        {
            name: '',
            field: '',
            headerClass:
                'th-component-header align-center th-vertical-bottom cursor-initial',
            fieldClass: 'tr-data',
            sortable: false,
            displayFn: () =>
                `
            <span data-video-icon style="inline-block; padding: 2px; border-radius: 50%; border: 2px solid #c2c2c2;">
                <img src="/site-core/images/video.png" style="width: 18px; cursor: pointer;">
            </span>
            `,
        },
    ]

    const colspan = serverParams.splitYears ? 5 : 4
    const secondaryHeaders = [
        {
            name: '',
            colspan,
            headerClass: 'th-name-header',
        },
        {
            name: 'Runs Breakdown',
            colspan: 3,
            headerClass: 'th-title-header',
        },
        {
            name: 'How often does the runner attempt to advance',
            colspan: 4,
            headerClass: 'th-title-header',
        },
        {
            name: 'How often was the runner successful in advancing',
            colspan: 3,
            headerClass: 'th-title-header',
        },
    ]
    // eslint-disable-next-line no-new
    new Table({
        id: tableDivId,
        repeatHeader,
        secondaryHeaders,
        headers,
        highlightFalsy: false,
        data,
        uniqueId: 'catcher_id', // this can't have dashes in it
        defaultSort,
        defaultSortDirection,
        sortClass: 'column-sort',
        showRank: true,
        sortCallback(column, _, { state }) {
            const url = new URL(window.location)
            url.searchParams.set('sortColumn', column)
            url.searchParams.set('sortDirection', state)
            window.history.replaceState('', '', url.toString())
        },
        subDataId: 'row_id',
    })
}
const $input = document.querySelector('.table-search')

if (data && data.length) {
    loadTable(currentData)

    if ($input) {
        $input.addEventListener('input', (e) => {
            currentData = getFilteredData(e.target.value)
            loadTable(currentData)
        })
    }
}

function showWithTeam(value) {
    if (is_team_type) {
        return
    }

    const display = ['', 'split'].includes(value) ? 'none' : 'inline-flex'
    document.getElementById('with-team-only-wrapper').style.display = display
}

document.querySelectorAll('.form-control').forEach((el) => {
    el.addEventListener('change', (e) => {
        const id = el.getAttribute('id')
        const type = id.slice(3)
        const { selectedIndex } = e.target
        document.querySelector(`.label-change-${type}`).innerText =
            e.target.value === 'split'
                ? 'All - Split by Team'
                : e.target[selectedIndex].text

        if (type === 'Team') {
            showWithTeam(e.target.value)
        }
    })
})

showWithTeam(serverParams.team || '')

function populateUrl() {
    const parameters = {
        game_type: document.getElementById('ddlGameType').value,
        n: document.getElementById('ddlMinOpps').value,
        key_base_out: document.getElementById('ddlKeyBaseOut').value,
        season_end: document.getElementById('ddlSeasonEnd').value,
        season_start: document.getElementById('ddlSeasonStart').value,
        split: document.getElementById('ddlSplitYears').value,
        team: document.getElementById('ddlTeam').value,
        type: document.getElementById('ddlGroup').value,
        with_team_only: document.getElementById('with-team-only').checked
            ? 1
            : 0,
    }

    const urlParams = new URLSearchParams(parameters)

    return `${window.location.pathname}?${urlParams.toString()}`
}

document.getElementById('btn-update').addEventListener('click', () => {
    window.location = populateUrl()
})

// let expanded = false
// document.getElementById('btn-columns').addEventListener('click', () => {
//     expanded = !expanded
//     document.getElementById('btn-columns').innerText = expanded
//         ? 'Show Less Columns'
//         : 'Show More Columns'
//     loadTable(currentData, expanded)
// })

// HT: https://codepen.io/ivanwebstudio/pen/OJVzPBL?editors=0110
/* eslint-disable no-param-reassign */
function slideUp(target, duration = 500) {
    target.style.transitionProperty = 'height, margin, padding'
    target.style.transitionDuration = `${duration}ms`
    target.style.boxSizing = 'border-box'
    target.style.height = `${target.offsetHeight}px`
    // eslint-disable-next-line no-unused-expressions, @typescript-eslint/no-unused-expressions
    target.offsetHeight
    target.style.overflow = 'hidden'
    target.style.height = 0
    target.style.paddingTop = 0
    target.style.paddingBottom = 0
    target.style.marginTop = 0
    target.style.marginBottom = 0
    window.setTimeout(() => {
        target.style.display = 'none'
        target.style.removeProperty('height')
        target.style.removeProperty('padding-top')
        target.style.removeProperty('padding-bottom')
        target.style.removeProperty('margin-top')
        target.style.removeProperty('margin-bottom')
        target.style.removeProperty('overflow')
        target.style.removeProperty('transition-duration')
        target.style.removeProperty('transition-property')
    }, duration)
}

function slideDown(target, duration = 500) {
    target.style.removeProperty('display')
    let { display } = window.getComputedStyle(target)

    if (display === 'none') display = 'block'

    target.style.display = display
    const height = target.offsetHeight
    target.style.overflow = 'hidden'
    target.style.height = 0
    target.style.paddingTop = 0
    target.style.paddingBottom = 0
    target.style.marginTop = 0
    target.style.marginBottom = 0
    // eslint-disable-next-line no-unused-expressions, @typescript-eslint/no-unused-expressions
    target.offsetHeight
    target.style.boxSizing = 'border-box'
    target.style.transitionProperty = 'height, margin, padding'
    target.style.transitionDuration = `${duration}ms`
    target.style.height = `${height}px`
    target.style.removeProperty('padding-top')
    target.style.removeProperty('padding-bottom')
    target.style.removeProperty('margin-top')
    target.style.removeProperty('margin-bottom')
    window.setTimeout(() => {
        target.style.removeProperty('height')
        target.style.removeProperty('overflow')
        target.style.removeProperty('transition-duration')
        target.style.removeProperty('transition-property')
    }, duration)
}

document.getElementById(tableDivId).addEventListener('click', async (e) => {
    const $a = e.target.closest('a')

    if ($a) {
        return
    }

    const $el = e.target.closest('tr.default-table-row')
    const $drawer = e.target.closest('.table-drawer')

    if (!$el || $drawer) {
        return
    }

    const id = `data_${$el.dataset.id}`
    const $innerDiv = document.getElementById(id)

    const $sub = $el.nextSibling

    const isOpen = $sub.dataset.open === 'true'

    // Close drawer
    if ($innerDiv && isOpen) {
        slideUp($innerDiv, 400)
        $sub.dataset.open = 'false'
        $el.querySelector('[data-video-icon]').style.backgroundColor = 'white'
        return
    }

    // Open drawer color
    $el.querySelector('[data-video-icon]').style.backgroundColor = '#797979'

    // Open Drawer
    if ($innerDiv && !isOpen) {
        slideDown($innerDiv, 400)
        $sub.dataset.open = 'true'
        return
    }

    const $td = $sub.querySelector('td')

    const params = new URLSearchParams(window.location.search)

    // Eww.
    const [entity_id, year, team_id] = $el.dataset.id.split('_')

    params.set(
        'season_start',
        serverParams.splitYears ? year : params.get('season_start') || ''
    )
    params.set(
        'season_end',
        serverParams.splitYears ? year : params.get('season_end') || ''
    )
    params.set(
        'team',
        serverParams.team === 'split' ? team_id : params.get('team') || ''
    )

    const $wrapperDiv = document.createElement('div')

    $wrapperDiv.classList.add('table-drawer')
    $wrapperDiv.textContent = 'Loading...'
    // NO DASHES ALLOWED!
    $wrapperDiv.id = id

    $sub.style.display = 'table-row'
    $sub.dataset.open = 'true'

    $td.appendChild($wrapperDiv)

    const url = `/leaderboard/services/baserunning/${entity_id}?${params.toString()}`

    const { data } = await fetch(url).then((res) => res.json())

    // Create DIV

    $wrapperDiv.style.display = 'none'
    $wrapperDiv.textContent = ''

    const $tableDiv = document.createElement('div')
    $tableDiv.id = `sub_table_${id}`

    $wrapperDiv.appendChild($tableDiv)

    const headerClass =
        'th-component-header align-center th-vertical-middle plus-sign component-col'
    const fieldClass = 'tr-data'
    const runnerRuns = {
        name: 'Runner Runs',
        field: 'runner_runs',
        headerClass,
        fieldClass,
        type: 'number',
        displayFn: (val) => {
            const str = Number(val).toFixed(2)

            return 1 / Number(str) === -Infinity ? '0.00' : str
        },
    }
    const fielderRuns = {
        name: 'Fielder Runs',
        field: 'fielder_runs',
        headerClass,
        fieldClass,
        type: 'number',
        displayFn: (val) => {
            const str = Number(val).toFixed(2)

            return 1 / Number(str) === -Infinity ? '0.00' : str
        },
    }

    // eslint-disable-next-line no-new
    new Table({
        id: $tableDiv.id,
        data,
        sortClass: 'column-sort',
        headers: [
            { name: 'Date', field: 'game_date', headerClass, fieldClass },
            {
                name: 'Situation',
                field: 'base_out_text',
                headerClass,
                fieldClass,
            },
            {
                name: 'Attempt XB?',
                field: 'is_att_xb',
                headerClass,
                displayFn: (val) => (val === 1 ? 'Yes' : 'No'),
                fieldClass,
            },
            {
                name: 'Result',
                field: 'result',
                headerClass,
                fieldClass,
            },
            isFielderView ? fielderRuns : runnerRuns,
            {
                name: '',
                field: 'entity_id',
                headerClass:
                    'th-component-header align-center th-vertical-bottom video-col cursor-initial',
                fieldClass: 'tr-data video-col',
                type: 'number',
                sortable: false,
                displayFn: (value, { play_id }) => `
                            <a href="/sporty-videos?playId=${play_id}" target="_BLANK">
                                <img src="/site-core/images/video.png" style="margin-right: 4px; width: 25px; height: 13px; cursor: pointer;">
                            </a>
                           `,
            },
        ],
        defaultSort: 'game_date',
    })

    // $wrapperDiv.innerHTML = `
    // <div class="drawer-tabs">
    //     <button data-tab="all" class="tab-all drawer-nav active" >
    //         All Attempts
    //     </button>
    //     <button data-tab="catcher_id" class="tab-catcher drawer-nav" style="display: ${
    //         serverParams.entity_code !== 'Cat' ? 'block' : 'none'
    //     }">
    //         Catchers
    //     </button>
    //     <button data-tab="fielder_id" class="tab-fielder drawer-nav" >
    //         Fielders
    //     </button>
    //     <button data-tab="pitcher_id" class="tab-pitcher drawer-nav" >
    //         Pitchers
    //     </button>
    //     <button data-tab="runner_id" class="tab-runner drawer-nav" >
    //         Runners
    //     </button>
    //     <button data-tab="throw_type" class="tab-runner drawer-nav" >
    //         Throw Types
    //     </button>
    // </div>
    // `

    slideDown($wrapperDiv, 400)
})

function getFilteredData(search) {
    const normalized_search = search
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()

    return data.filter((d) => {
        const name = d.entity_name
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()

        return name.includes(normalized_search)
    })
}
document.getElementById('btn-csv').addEventListener('click', () => {
    window.location.href = window.location.search
        ? `${window.location.href}&csv=true`
        : `${window.location.href}?csv=true`
})
